import { createAction } from '../util/';

export const toggleNavMenu = createAction('NAVIGATION_MENU_TOGGLE', { noPayload: true });
export const closeNavMenu = createAction('NAVIGATION_MENU_CLOSE', { noPayload: true });
export const openNavMenu = createAction('NAVIGATION_MENU_OPEN', { noPayload: true });

export const toggleAccountMenu = createAction('NAVIGATION_ACCOUNT_MENU_TOGGLE', { noPayload: true });

export const toggleNavigationMain = createAction('NAVIGATION_MAIN_TOGGLE', { noPayload: true });

export const toggleHideDefaultTopNavigation = createAction('TOGGLE_HIDE_DEFAULT_TOP_NAVIGATION');
